import React from 'react';
import { useParams } from 'react-router-dom';
import { BacktestTab } from './BacktestTab';
import { Box } from '../../core';
import { BacktestType } from '@sc1/common';

interface IPosition {
  position: BacktestType;
  label: string;
}

export const BacktestTabs = (props: any): JSX.Element => {
  const { position: currentPosition = 'shortLp' }: { position: BacktestType } =
    useParams();
  const positions: IPosition[] = [
    { position: 'shortLp', label: 'Short LP' },
    { position: 'longLp', label: 'Long LP' },
    { position: 'perpetual', label: 'Perpetual' },
  ];
  return (
    <Box {...props}>
      {positions.map(({ position, label }) => (
        <BacktestTab
          key={position + label}
          position={position}
          label={label}
          currentPosition={currentPosition}
        />
      ))}
    </Box>
  );
};
